import {
    BUSINESS_EVENTBRITE_CATEGORY,
    FILM_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SCIENCE_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import { BrandState } from '../../types/index';

// "You've Got Plans" marketing campaign
import {
    ENGLISH_TLDs,
    TLD_AUSTRALIA,
    TLD_CANADA,
    TLD_IRELAND,
    TLD_NEW_ZEALAND,
    TLD_UNITED_KINGDOM,
    TLD_UNITED_STATES,
} from '../../constants/constants';

// "You've Got Plans" marketing campaign
import YGP_HEADER_CHI from '../../static/images/browse/YGP_citybrowseheader_CHI_791x488px@2x.webp';
import YGP_HEADER_DC from '../../static/images/browse/YGP_citybrowseheader_DC_791x488px@2x.webp';
import YGP_HEADER_GENERIC from '../../static/images/browse/YGP_citybrowseheader_Generic_791x488px@2x.webp';
import YGP_HEADER_LA from '../../static/images/browse/YGP_citybrowseheader_LA_791x488px@2x.webp';
import YGP_HEADER_LDN from '../../static/images/browse/YGP_citybrowseheader_LDN_791x488px@2x.webp';
import YGP_HEADER_NYC from '../../static/images/browse/YGP_citybrowseheader_NYC_791x488px@2x.webp';
import YGP_HEADER_SF from '../../static/images/browse/YGP_citybrowseheader_SF_791x488px@2x.webp';

import ATLANTA_DESKTOP from '../../static/images/browse/banner/atlanta_desktop.webp';
import ATLANTA_MOBILE from '../../static/images/browse/banner/atlanta_mobile.webp';

import AUSTIN_DESKTOP from '../../static/images/browse/banner/austin_desktop.webp';
import AUSTIN_MOBILE from '../../static/images/browse/banner/austin_mobile.webp';

import CHICAGO_DESKTOP from '../../static/images/browse/banner/chicago_desktop.webp';
import CHICAGO_MOBILE from '../../static/images/browse/banner/chicago_mobile.webp';

import LONDON_DESKTOP from '../../static/images/browse/banner/london_desktop.webp';
import LONDON_MOBILE from '../../static/images/browse/banner/london_mobile.webp';

import LOS_ANGELES_DESKTOP from '../../static/images/browse/banner/los_angeles_desktop.webp';
import LOS_ANGELES_MOBILE from '../../static/images/browse/banner/los_angeles_mobile.webp';

import MELBOURNE_DESKTOP from '../../static/images/browse/banner/melbourne_desktop.webp';
import MELBOURNE_MOBILE from '../../static/images/browse/banner/melbourne_mobile.webp';

import MIAMI_DESKTOP from '../../static/images/browse/banner/miami_desktop.webp';
import MIAMI_MOBILE from '../../static/images/browse/banner/miami_mobile.webp';

import NEW_YORK_DESKTOP from '../../static/images/browse/banner/new_york_desktop.webp';
import NEW_YORK_MOBILE from '../../static/images/browse/banner/new_york_mobile.webp';

import SAN_FRANCISCO_DESKTOP from '../../static/images/browse/banner/san_francisco_desktop.webp';
import SAN_FRANCISCO_MOBILE from '../../static/images/browse/banner/san_francisco_mobile.webp';

import TORONTO_DESKTOP from '../../static/images/browse/banner/toronto_desktop.webp';
import TORONTO_MOBILE from '../../static/images/browse/banner/toronto_mobile.webp';

import WASHINGTON_DC_DESKTOP from '../../static/images/browse/banner/washington_dc_desktop.webp';
import WASHINGTON_DC_MOBILE from '../../static/images/browse/banner/washington_dc_mobile.webp';

import BALTIMORE_DESKTOP from '../../static/images/browse/banner/baltimore_desktop.webp';
import BALTIMORE_MOBILE from '../../static/images/browse/banner/baltimore_mobile.webp';

import BOSTON_DESKTOP from '../../static/images/browse/banner/boston_desktop.webp';
import BOSTON_MOBILE from '../../static/images/browse/banner/boston_mobile.webp';

import CHARLOTTE_DESKTOP from '../../static/images/browse/banner/charlotte_desktop.webp';
import CHARLOTTE_MOBILE from '../../static/images/browse/banner/charlotte_mobile.webp';

import DALLAS_DESKTOP from '../../static/images/browse/banner/dallas_desktop.webp';
import DALLAS_MOBILE from '../../static/images/browse/banner/dallas_mobile.webp';

import DENVER_DESKTOP from '../../static/images/browse/banner/denver_desktop.webp';
import DENVER_MOBILE from '../../static/images/browse/banner/denver_mobile.webp';

import DETROIT_DESKTOP from '../../static/images/browse/banner/detroit_desktop.webp';
import DETROIT_MOBILE from '../../static/images/browse/banner/detroit_mobile.webp';

import DUBLIN_DESKTOP from '../../static/images/browse/banner/dublin_desktop.webp';
import DUBLIN_MOBILE from '../../static/images/browse/banner/dublin_mobile.webp';

import HOUSTON_DESKTOP from '../../static/images/browse/banner/houston_desktop.webp';
import HOUSTON_MOBILE from '../../static/images/browse/banner/houston_mobile.webp';

import LAS_VEGAS_DESKTOP from '../../static/images/browse/banner/las_vegas_desktop.webp';
import LAS_VEGAS_MOBILE from '../../static/images/browse/banner/las_vegas_mobile.webp';

import MINNEAPOLIS_DESKTOP from '../../static/images/browse/banner/minneapolis_desktop.webp';
import MINNEAPOLIS_MOBILE from '../../static/images/browse/banner/minneapolis_mobile.webp';

import ORLANDO_DESKTOP from '../../static/images/browse/banner/orlando_desktop.webp';
import ORLANDO_MOBILE from '../../static/images/browse/banner/orlando_mobile.webp';

import PHILADELPHIA_DESKTOP from '../../static/images/browse/banner/philadelphia_desktop.webp';
import PHILADELPHIA_MOBILE from '../../static/images/browse/banner/philadelphia_mobile.webp';

import PHOENIX_DESKTOP from '../../static/images/browse/banner/phoenix_desktop.webp';
import PHOENIX_MOBILE from '../../static/images/browse/banner/phoenix_mobile.webp';

import SAN_DIEGO_DESKTOP from '../../static/images/browse/banner/san_diego_desktop.webp';
import SAN_DIEGO_MOBILE from '../../static/images/browse/banner/san_diego_mobile.webp';

import SAN_JOSE_DESKTOP from '../../static/images/browse/banner/san_jose_desktop.webp';
import SAN_JOSE_MOBILE from '../../static/images/browse/banner/san_jose_mobile.webp';

import SEATTLE_DESKTOP from '../../static/images/browse/banner/seattle_desktop.webp';
import SEATTLE_MOBILE from '../../static/images/browse/banner/seattle_mobile.webp';

import SYDNEY_DESKTOP from '../../static/images/browse/banner/sydney_desktop.webp';
import SYDNEY_MOBILE from '../../static/images/browse/banner/sydney_mobile.webp';

import TAMPA_DESKTOP from '../../static/images/browse/banner/tampa_desktop.webp';
import TAMPA_MOBILE from '../../static/images/browse/banner/tampa_mobile.webp';

import VANCOUVER_DESKTOP from '../../static/images/browse/banner/vancouver_desktop.webp';
import VANCOUVER_MOBILE from '../../static/images/browse/banner/vancouver_mobile.webp';

import GENERIC_1_DESKTOP from '../../static/images/browse/banner/generic_1_desktop.webp';
import GENERIC_1_MOBILE from '../../static/images/browse/banner/generic_1_mobile.webp';

import { random } from 'lodash';
import GENERIC_2_DESKTOP from '../../static/images/browse/banner/generic_2_desktop.webp';
import GENERIC_2_MOBILE from '../../static/images/browse/banner/generic_2_mobile.webp';

// List of buckets that should link to new browse page
export const BROWSE_PAGE_LINK_KEYS: string[] = [
    'performing_and_visual_arts_events',
    'science_and_technology_events',
    'business_and_professional_events',
    'food_and_drink_events',
    'music_events',
    'film_media_and_entertainment_events',
    'health_and_wellness_events',
];

export const BROWSE_BUCKET_CATEGORY_MAP: Record<string, string> = {
    performing_and_visual_arts_events: PERFORMING_EVENTBRITE_CATEGORY,
    science_and_technology_events: SCIENCE_EVENTBRITE_CATEGORY,
    business_and_professional_events: BUSINESS_EVENTBRITE_CATEGORY,
    food_and_drink_events: FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    music_events: MUSIC_EVENTBRITE_CATEGORY,
    film_media_and_entertainment_events: FILM_EVENTBRITE_CATEGORY,
    health_and_wellness_events: HEALTH_EVENTBRITE_CATEGORY,
};

export const BROWSE_BANNER_PLACE_OVERRIDES: {
    [placeId: string]: Partial<BrandState>;
} = {
    // New York
    '85977539': {
        headerImageUrl: NEW_YORK_DESKTOP,
        headerSmallImageUrl: NEW_YORK_MOBILE,
    },
    // San Francisco
    '85922583': {
        headerImageUrl: SAN_FRANCISCO_DESKTOP,
        headerSmallImageUrl: SAN_FRANCISCO_MOBILE,
    },
    // Los Angeles
    '85923517': {
        headerImageUrl: LOS_ANGELES_DESKTOP,
        headerSmallImageUrl: LOS_ANGELES_MOBILE,
    },
    // Chicago
    '85940195': {
        headerImageUrl: CHICAGO_DESKTOP,
        headerSmallImageUrl: CHICAGO_MOBILE,
    },
    // Washington DC
    '85931779': {
        headerImageUrl: WASHINGTON_DC_DESKTOP,
        headerSmallImageUrl: WASHINGTON_DC_MOBILE,
    },
    // London
    '101750367': {
        headerImageUrl: LONDON_DESKTOP,
        headerSmallImageUrl: LONDON_MOBILE,
    },
    // Miami
    '85933669': {
        headerImageUrl: MIAMI_DESKTOP,
        headerSmallImageUrl: MIAMI_MOBILE,
    },
    // Atlanta
    '85936429': {
        headerImageUrl: ATLANTA_DESKTOP,
        headerSmallImageUrl: ATLANTA_MOBILE,
    },
    // Toronto
    '101735835': {
        headerImageUrl: TORONTO_DESKTOP,
        headerSmallImageUrl: TORONTO_MOBILE,
    },
    // Melbourne
    '101933229': {
        headerImageUrl: MELBOURNE_DESKTOP,
        headerSmallImageUrl: MELBOURNE_MOBILE,
    },
    // Austin
    '101724577': {
        headerImageUrl: AUSTIN_DESKTOP,
        headerSmallImageUrl: AUSTIN_MOBILE,
    },
    // Baltimore
    '85949461': {
        headerImageUrl: BALTIMORE_DESKTOP,
        headerSmallImageUrl: BALTIMORE_MOBILE,
    },
    // Boston
    '85950361': {
        headerImageUrl: BOSTON_DESKTOP,
        headerSmallImageUrl: BOSTON_MOBILE,
    },
    // Charlotte
    '85981333': {
        headerImageUrl: CHARLOTTE_DESKTOP,
        headerSmallImageUrl: CHARLOTTE_MOBILE,
    },
    // Dallas
    '101724385': {
        headerImageUrl: DALLAS_DESKTOP,
        headerSmallImageUrl: DALLAS_MOBILE,
    },
    // Denver
    '85928879': {
        headerImageUrl: DENVER_DESKTOP,
        headerSmallImageUrl: DENVER_MOBILE,
    },
    // Detroit
    '85951091': {
        headerImageUrl: DETROIT_DESKTOP,
        headerSmallImageUrl: DETROIT_MOBILE,
    },
    // Dublin
    '101751737': {
        headerImageUrl: DUBLIN_DESKTOP,
        headerSmallImageUrl: DUBLIN_MOBILE,
    },
    // Houston
    '101725629': {
        headerImageUrl: HOUSTON_DESKTOP,
        headerSmallImageUrl: HOUSTON_MOBILE,
    },
    // Las Vegas
    '85974801': {
        headerImageUrl: LAS_VEGAS_DESKTOP,
        headerSmallImageUrl: LAS_VEGAS_MOBILE,
    },
    // Minneapolis (including St. Paul)
    '85969169': {
        headerImageUrl: MINNEAPOLIS_DESKTOP,
        headerSmallImageUrl: MINNEAPOLIS_MOBILE,
    },
    // Orlando
    '85933091': {
        headerImageUrl: ORLANDO_DESKTOP,
        headerSmallImageUrl: ORLANDO_MOBILE,
    },
    // Philadelphia
    '101718083': {
        headerImageUrl: PHILADELPHIA_DESKTOP,
        headerSmallImageUrl: PHILADELPHIA_MOBILE,
    },
    // Phoenix
    '85917479': {
        headerImageUrl: PHOENIX_DESKTOP,
        headerSmallImageUrl: PHOENIX_MOBILE,
    },
    // San Diego
    '85922227': {
        headerImageUrl: SAN_DIEGO_DESKTOP,
        headerSmallImageUrl: SAN_DIEGO_MOBILE,
    },
    // San Jose
    '85922347': {
        headerImageUrl: SAN_JOSE_DESKTOP,
        headerSmallImageUrl: SAN_JOSE_MOBILE,
    },
    // Seattle
    '101730401': {
        headerImageUrl: SEATTLE_DESKTOP,
        headerSmallImageUrl: SEATTLE_MOBILE,
    },
    // Sydney
    '101932003': {
        headerImageUrl: SYDNEY_DESKTOP,
        headerSmallImageUrl: SYDNEY_MOBILE,
    },
    // Tampa
    '85931789': {
        headerImageUrl: TAMPA_DESKTOP,
        headerSmallImageUrl: TAMPA_MOBILE,
    },
    // Vancouver
    '101741075': {
        headerImageUrl: VANCOUVER_DESKTOP,
        headerSmallImageUrl: VANCOUVER_MOBILE,
    },
};

const HEADER_GENERIC_LIST = [
    {
        headerImageUrl: GENERIC_1_DESKTOP,
        headerSmallImageUrl: GENERIC_1_MOBILE,
    },
    {
        headerImageUrl: GENERIC_2_DESKTOP,
        headerSmallImageUrl: GENERIC_2_MOBILE,
    },
];

const headerImageSetSelector = (headerImageList: string | any[]) => {
    const randomIndex = random(headerImageList.length - 1);
    return headerImageList[randomIndex];
};

export const GENERIC_BANNER = headerImageSetSelector(HEADER_GENERIC_LIST);

export const BROWSE_BANNER_TLD_OVERRIDES: {
    [tld in typeof ENGLISH_TLDs[number]]: Partial<BrandState>;
} = {
    [TLD_CANADA]: GENERIC_BANNER,
    [TLD_NEW_ZEALAND]: GENERIC_BANNER,
    [TLD_AUSTRALIA]: GENERIC_BANNER,
    [TLD_UNITED_KINGDOM]: GENERIC_BANNER,
    [TLD_IRELAND]: GENERIC_BANNER,
    [TLD_UNITED_STATES]: GENERIC_BANNER,
};

export const BROWSE_HEADER_PLACE_OVERRIDES: {
    [placeId: string]: Partial<BrandState>;
} = {
    // New York
    '85977539': {
        headerImageUrl: YGP_HEADER_NYC,
    },
    // San Francisco
    '85922583': {
        headerImageUrl: YGP_HEADER_SF,
    },
    // Los Angeles
    '85923517': {
        headerImageUrl: YGP_HEADER_LA,
    },
    // Chicago
    '85940195': {
        headerImageUrl: YGP_HEADER_CHI,
    },
    // Washington DC
    '85931779': {
        headerImageUrl: YGP_HEADER_DC,
    },
    // London
    '101750367': {
        headerImageUrl: YGP_HEADER_LDN,
    },
    // Add other places here...
};

const GENERIC_HEADER = {
    headerImageUrl: YGP_HEADER_GENERIC,
};
export const BROWSE_HEADER_TLD_OVERRIDES: {
    [tld in typeof ENGLISH_TLDs[number]]: Partial<BrandState>;
} = {
    [TLD_CANADA]: GENERIC_HEADER,
    [TLD_NEW_ZEALAND]: GENERIC_HEADER,
    [TLD_AUSTRALIA]: GENERIC_HEADER,
    [TLD_UNITED_KINGDOM]: GENERIC_HEADER,
    [TLD_IRELAND]: GENERIC_HEADER,
    [TLD_UNITED_STATES]: GENERIC_HEADER,
};

// Tracking for Heap
export const HEAP_PAGE_AREA = 'city-browse';
